import React from "react";
import { ArrowLeft, BarChart3, LockKeyhole, ShieldCheck } from "lucide-react";

const PermissionNotice = ({
  eyebrow = "View-only access",
  title = "You do not have permission to edit this survey",
  description = "Your role lets you view forms and results, but editing is limited to owners, admins, and editors.",
  primaryLabel,
  onPrimary,
  secondaryLabel = "Back to workspaces",
  onSecondary,
}) => {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4 py-12" style={{ fontFamily: "Inter" }}>
      <div className="w-full max-w-[620px] text-center">
        <div className="mx-auto mb-6 h-28 w-28 md:h-36 md:w-36 rounded-full bg-gray-50 border border-gray-100 flex items-center justify-center">
          <div className="h-16 w-16 md:h-20 md:w-20 rounded-2xl bg-black text-white flex items-center justify-center shadow-sm">
            <LockKeyhole size={30} />
          </div>
        </div>

        <div className="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-gray-50 px-3 py-1 text-xs font-medium text-gray-700 mb-4">
          <ShieldCheck size={14} />
          {eyebrow}
        </div>

        <h1 className="text-2xl md:text-3xl font-normal text-black tracking-[-0.02em] mb-3">
          {title}
        </h1>

        <p className="text-sm md:text-base text-gray-600 leading-7 max-w-md mx-auto mb-8">
          {description}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          {primaryLabel && (
            <button
              onClick={onPrimary}
              className="h-10 w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-lg bg-black px-5 text-sm font-medium text-white hover:bg-gray-900 transition-colors"
            >
              <BarChart3 size={16} />
              {primaryLabel}
            </button>
          )}
          {secondaryLabel && (
            <button
              onClick={onSecondary}
              className="h-10 w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-lg border border-gray-300 bg-white px-5 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
            >
              <ArrowLeft size={16} />
              {secondaryLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PermissionNotice;
